<template>
  <div class="admin-layout">
    <admin-header/>
    <admin-sidenav/>

    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

    <div v-if="offline" class="alert danger fixed">
      Estas en modo offline, algunas funciones pueden no estar disponibles.
    </div>
  </div>
</template>

<script>
import '../assets/scss/we/admin.scss'
import Header from '@/components/admin/Header.vue'
import SideNav from '@/components/admin/SideNav.vue'

export default {
  components: {
    'admin-header': Header,
    'admin-sidenav': SideNav
  },
  data () {
    return {
      offline: false
    }
  },
  beforeMount () {
    window.addEventListener('online', this.handleNetworkChange);
    window.addEventListener('offline', this.handleNetworkChange);
    this.handleNetworkChange()
  },
  methods: {
    handleNetworkChange (event) {
      if (navigator.onLine) {
        this.offline = false
      } else {
        this.offline = true
      }
    }
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
